<!-- activity.component.html -->
<div *ngIf="saved" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">
        <!-- Saved successfully -->
        {{'appointments.gui.labels.Saved Successfully' | translate}}
    </h2>
      <button
        (click)="saved = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>
<div class="wrapper">
    <div class="m-box">
        <h2>
            <!-- Activity Hours -->
            {{'appointments.gui.labels.Activity Hours' | translate}}
        </h2>
        <button class="blue-btn" [matTooltip]="'appointments.gui.tooltips.Save Changes' | translate" (click)="saveActivityHours()">
            <!-- Save -->
            {{'appointments.gui.buttons.Save' | translate}}
        </button>
        <div class="flex-rox-space"
            *ngFor="let day of ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']">
                <h3 class="w5 rtl">
                    {{'appointments.gui.Days.'+day | translate | titlecase }}
                </h3>
            <div style="display: flex; flex-direction: column; gap: 1em;">



                <div *ngFor="let hour of activityHours[day]; let i = index" style="display: flex; gap: 1em; align-items: center;">
                    <ng-container *ngIf="hour.status !== 'delete'">
                        <!-- <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                            <label class="w50" style="white-space: nowrap;">{{ 'appointments.gui.labels.Payer' | translate }}
                            </label>
                            <select class="t-select w100"  [(ngModel)]="activityHours[day][i].Payer" (change)="markAsUpdated(day, i)" multiple >
                                <option *ngFor="let Payer of getPayers()" [value]="Payer">
                                    {{ 'appointments.gui.hmo.'+Payer | translate }}
                                </option>
                              </select>
                        </div> -->
                        <mat-form-field>
                            <mat-label [ngClass]="['mat-select-value']"> {{ 'appointments.gui.labels.Payer' | translate }}</mat-label>
                            <mat-select [(ngModel)]="activityHours[day][i].Payer" multiple (selectionChange)="markAsUpdated(day, i)" [ngClass]="['mat-select-value','mat-form-field']">
                              <mat-option  *ngFor="let Payer of getPayers()" [value]="Payer" [ngClass]="['mat-select-value']"> {{ 'appointments.gui.hmo.'+Payer | translate }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">שעת סיום</label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].endTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">שעת התחלה</label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].startTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <img class="delete-hour"  [matTooltip]="'appointments.gui.tooltips.Delete Hour' | translate" (click)="deleteHour(day,i)" src="../../assets/icons/minus-blue.svg" />
                </ng-container>
                </div>
                <hr style="width: 100%; opacity: 0.3;">
            </div>
            <div  style="display: flex;
            justify-content: flex-end;
            align-items: end;"  >

                <img class="add-hour" [matTooltip]="'appointments.gui.tooltips.Add Hour' | translate" (click)="addHour(day)" src="../../assets/icons/plus-orange.svg" />
            </div>

        </div>
        
    </div>
</div>